import React from 'react'
import DietPlanIcon from '../Assets/images/Diet Plan Icon.png'
import lifestyleicon from '../Assets/images/Lifestyle Practices Icon.png'
import TeleIcon from '../Assets/images/Teleconsultation Icon.png'
import ChatIcon from '../Assets/images/Chat Icon.png'
import consultationIcon from '../Assets/images/Group 8844.png'
import RecipesIcon from '../Assets/images/Recipes Icon.png'
import WelcomeScreenanimation from '../Assets/animations/welcomscreenrotation.json';
import axios from 'axios';
import Lottie from 'lottie-react';
import HerbalProductsIcon from '../Assets/images/Herbal Products Icon.png'
import teleicon from '../Assets/images/Group 15066.png'
import goalicon from '../Assets/images/tele_icon.png'
import { Button } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'

function PackageListing() {

    const holistic_care = [{
        img: DietPlanIcon,
        info: "Your Path to Better Eating",
        name: "Diet & Recipe Plans"
    }, {
        img: teleicon,
        info: "Expert Health Guidance",
        name: "Teleconsultation"
    },

    {
        img: lifestyleicon,
        info: "A Smarter Path to Wellness",
        name: "Lifestyle Practices"
    },

    {
        img: goalicon,
        info: "Track, Improve, Elevate",
        name: "Health Goals Tracking"
    }]

    const navigate = useNavigate()
    const location = useLocation()

    return (
        <div className='Packages-listing-page-section'>
            <div className='Packages-listing-section'>
                {/* <div>
                    <p>Transform your wellness journey with <br /> expert guidance & holistic care</p>
                   
                    <div className="package-arrow mt-5 flex items-center justify-evenly">
                        <p>₹499</p>
                        <p><del>₹999</del></p>
                        <p>3months</p>
                    </div>

                    <div className='flex items-center p-5 m-2 mt-5 gap-5'
                        style={{ backgroundColor: "#F1EFEC", borderRadius: "5px" }}>
                        <img src={TeleIcon} style={{ width: "3rem" }}>
                        </img>
                        <p>Free Tele-Consultations </p>
                    </div>

                    <div className='holistic-care mt-5'>
                        <p>Expert Recommendations</p>
                        <div className='mt-2'>
                            {
                                holistic_care.map((e) => {
                                    return <div>
                                        <img src={e.img}></img>
                                        <p>{e.name}</p>
                                    </div>
                                })
                            }
                        </div>
                    </div>

                    <div className='mt-5'>
                        <Button
                            style={{
                                width: '100%',
                                textTransform: 'none',
                                borderRadius: '0',
                                backgroundColor: '#DA6E0B',
                                color: 'white',
                                border: 'none',
                                boxSizing: 'border-box',
                                borderRadius: "5px",
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: "10px"
                            }}

                            onClick={() => {
                                navigate('/Signup?Link=Wellness-Package')
                            }
                            }
                        >
                            Sign Up to Proceed
                        </Button>
                    </div>

                </div>

                <div className='Select-tele-section'>
                    
                    <img src={consultationIcon}></img>
                    
                    <p>If you are <span> not sure about <br />the Wellness Packages </span> we kindly <br />suggesting you to consult an <br />Ayurveda Physician </p>
                    
                    <div className="package-arrow mt-5 flex items-center justify-evenly">
                        <p>Just at ₹400/ 30 minutes</p>
                    </div>

                    <div className='mt-5' style={{ justifySelf: "flex-end", marginTop: "auto" }}>
                        <Button
                            style={{
                                width: '100%',
                                textTransform: 'none',
                                borderRadius: '0',
                                border: "1px solid #DA6E0B ",
                                color: '#DA6E0B',
                                boxSizing: 'border-box',
                                borderRadius: "5px",
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: "10px"
                            }}
                            onClick={() => {
                                navigate('/Signup?Link=Tele-Consultation')
                            }}
                        >
                            Consult Now
                        </Button>
                    </div>

                </div> */}


                <div className='w-100 flex flex-col  w-100'>

                    <div className="Welcome-section-animation" style={{ alignSelf: "center" }}>
                        <div>
                            <Lottie animationData={WelcomeScreenanimation} />
                        </div>
                    </div>

                    <div className='mt-5 pklistTitle text-center'>
                        <p>Achieve a Healthier, Happier You!</p>
                    </div>

                    <div className='pklistcontainer mt-5'>
                        {
                            holistic_care && holistic_care.map((e) => {
                                return <div className='pkinfolist'>
                                    <div>
                                        <img src={e.img}></img>
                                    </div>
                                    <div >
                                        <p>{e.info}</p>
                                        <p>{e.name}</p>
                                    </div>
                                </div>
                            })
                        }
                    </div>

                    <div className='mt-5 pklistprice' style={{ alignSelf: "center" }}>
                        <div className="border rounded-xl p-3">
                            <p className="text-base font-semibold mb-1">3 Months Plan</p>
                            <div className="flex justify-center items-baseline gap-2">
                                <p className="line-through text-gray-500 text-sm">₹3000</p>
                                <p className="text-xl font-bold text-green-600">₹1500</p>
                            </div>
                        </div>

                        <div>
                            <p>Reset-Rebuild-Rejuvenate</p>
                        </div>
                    </div>

                    <div className='mt-4' style={{ alignSelf: "center" }}>
                        <Button
                            style={{
                                width: '100%',
                                textTransform: 'none',
                                borderRadius: '0',
                                backgroundColor: '#DA6E0B',
                                color: 'white',
                                border: 'none',
                                boxSizing: 'border-box',
                                borderRadius: '5px',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '8px 3rem'
                            }}

                            onClick={() => {
                                localStorage.setItem('userType', "Corporate User")
                                navigate('/signup', { state: { from: location?.state?.from } })
                            }}
                        >
                            Subscribe
                        </Button>
                    </div>

                    <div className='mt-4' style={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 400,
                        color: "#3B362A",
                        textAlign: "center",
                    }}>
                        <p>Start your wellness journey</p>
                    </div>

                    <div
                        className='explore-app mt-3 text-center w-100'
                        style={{ cursor: "pointer", width: "100%" }}
                    >
                        <p style={{ marginBottom: '0.25rem' }}>
                            Not sure about the wellness package?
                        </p>

                        <span
                            onClick={() => {
                                localStorage.setItem('ExploreApp', JSON.stringify({ selected: true }))
                                navigate('/signup', { state: { from: location?.state?.from } })
                            }}
                            className='ml-2'
                            style={{ color: '#DA6E0B', textDecoration: 'underline' }}
                        >
                            Explore Our App
                        </span>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default PackageListing